import {z} from 'zod';

export enum AssetViewName {
	MP3 = 'previewMp3',
	H264 = 'previewH264',
	PDF = 'previewPDF',
	VTT = 'previewVTT',
}

export const AssetViewSchema = z.object({
	viewId: z.number(),
	/** asset id (definitely) */
	imageId: z.number(),
	/** appears to be the asset id? */
	autoTaskId: z.number(),
	fileTypeId: z.number(),
	fileSize: z.number(),
	fileWidth: z.number(),
	fileHeight: z.number(),
	name: z.string().nonempty().or(z.nativeEnum(AssetViewName)),
	description: z.string(),
	creationDate: z.string(),
	thumb: z.string(),
	fileTypeLabel: z.string(),
	fileSizeLabel: z.string(),
	viewMetadataLabels: z.array(z.string()),
	viewMetadataValues: z.array(z.string()),
});
export type IAssetView = z.infer<typeof AssetViewSchema>;

export const AssetViewFormSchema = AssetViewSchema.pick({
	description: true,
	name: true,
});

export type IAssetViewFormValues = z.infer<typeof AssetViewFormSchema>;
